<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('fair-abroad')"
                    :links="values.fairAbroad"
                    :error-messages="errors.fairAbroad"
                    @input="setFieldValue('fairAbroad', $event)"
                    @delete="setFieldValue('fairAbroad', $event)"
                />
                <MultiLink
                    :label="$t('fair-abroad-cooperation')"
                    :links="values.fairAbroadCooperation"
                    :error-messages="errors.fairAbroadCooperation"
                    @input="setFieldValue('fairAbroadCooperation', $event)"
                    @delete="setFieldValue('fairAbroadCooperation', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventFairAbroadSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const fairAbroadId = computed(() => event.value?.fairAbroad?.id);
const fairAbroadCooperationId = computed(() => event.value?.fairAbroadCooperation?.id);

const fairAbroadLinks = computed(() => event.value?.fairAbroad?.links.nodes ?? []);
const fairAbroadCooperationLinks = computed(() => event.value?.fairAbroadCooperation?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventFairAbroadSchema,
    computed(() => ({
        fairAbroad: getFormFieldLinks(fairAbroadLinks),
        fairAbroadCooperation: getFormFieldLinks(fairAbroadCooperationLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            {
                id: fairAbroadId.value,
                fieldName: 'fairAbroad',
                links: values.value.fairAbroad,
            },
            {
                id: fairAbroadCooperationId.value,
                fieldName: 'fairAbroadCooperation',
                links: values.value.fairAbroadCooperation,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
